import React, { ComponentProps, useState } from 'react'
import useTranslation from 'next-translate/useTranslation'
import {
  ExpectRoot,
  Container,
  BackgroundImage,
  ContentWrapper,
  ExpectText1,
  ExpectText2,
  ExpectText3,
  ExpectText4,
  SquareImages,
  SectionTitle,
  DesktopWrapper,
  MobileWrapper,
  MobileContent,
  ExpectSquare,
  SquareImage,
  ButtonWrapper
} from './Expect.styles'
import { Text } from 'components/Text'
import Image from 'next/image'
import background from '../../../../../../public/assets/recipes/categories/individual/box-background.webp'
import squares from '../../../../../../public/assets/recipes/categories/individual/expect-squares.webp'
import mix from '../../../../../../public/assets/recipes/categories/individual/mixin.webp'
import instructions from '../../../../../../public/assets/recipes/categories/individual/instructions.webp'
import silicone from '../../../../../../public/assets/recipes/categories/individual/silicone-container.webp'
import balanced from '../../../../../../public/assets/recipes/categories/individual/balanced.webp'
import backgroundMobile from '../../../../../../public/assets/recipes/categories/individual/box-background-m.webp'
import Link from 'next/link'
import { Button } from 'components/Button'

type ExpectProps = {}

export const Expect = (props: ExpectProps) => {
  const { t } = useTranslation()

  return (
    <ExpectRoot>
      <Container>
        <BackgroundImage>
          <DesktopWrapper>
            <Image src={background} alt={t('recipes:individual.expect.background-img')}/>
          </DesktopWrapper>
          <MobileWrapper>
          <Image src={backgroundMobile} alt={t('recipes:individual.expect.background-img')}/>
          </MobileWrapper>
        </BackgroundImage>
        <ContentWrapper>
          <SectionTitle>{t('recipes:individual.expect.title')}</SectionTitle>
          <ExpectText1>{t('recipes:individual.expect.feat-1')}</ExpectText1>
          <ExpectText2>{t('recipes:individual.expect.feat-2')}</ExpectText2>
          <ExpectText3>{t('recipes:individual.expect.feat-3')}</ExpectText3>
          <ExpectText4>{t('recipes:individual.expect.feat-4')}</ExpectText4>
          <SquareImages>
            <Image src={squares} alt={t('recipes:individual.expect.squares-img')}/>
          </SquareImages>
          <ButtonWrapper>
          <Link href='/meal-plan'>
            <Button>{t('recipes:overview.cta-3')}</Button>
          </Link>
          </ButtonWrapper>
        </ContentWrapper>
         <MobileContent>
            <SectionTitle>{t('recipes:individual.expect.title-m')}</SectionTitle>
          <ExpectSquare>
            <SquareImage>
              <Image src={balanced} alt={t('recipes:individual.expect.feat-1')}/>
            </SquareImage>
            <Text weight="semiBold" size="h4" color="accent-black">{t('recipes:individual.expect.feat-1')}</Text>
          </ExpectSquare>
          <ExpectSquare>
            <SquareImage>
              <Image src={mix} alt={t('recipes:individual.expect.feat-2')}/>
            </SquareImage>
            <Text weight="semiBold" size="h4" color="accent-black">{t('recipes:individual.expect.feat-2')}</Text>
          </ExpectSquare>
          <ExpectSquare>
            <SquareImage>
              <Image src={silicone} alt={t('recipes:individual.expect.feat-3')}/>
            </SquareImage>
            <Text weight="semiBold" size="h4" color="accent-black">{t('recipes:individual.expect.feat-3')}</Text>
          </ExpectSquare>
          <ExpectSquare>
            <SquareImage>
              <Image src={instructions} alt={t('recipes:individual.expect.feat-4')}/>
            </SquareImage>
            <Text weight="semiBold" size="h4" color="accent-black">{t('recipes:individual.expect.feat-4')}</Text>
          </ExpectSquare>
          <Link href='/meal-plan'>
            <Button>{t('recipes:overview.cta-3')}</Button>
          </Link>
        </MobileContent> 
      </Container>
    </ExpectRoot>
  )
}

Expect.displayName = 'Expect'
